import { CloseModalButton } from '@library/components/buttons/CloseModalButton';
import { IconButton } from '@library/components/buttons';
import { Modal } from '@library/components/modals/Modal';
import { PencilIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { classNames } from '@library/utils';

interface StyledModalProps {
  bigTitle: string;
  children: React.ReactNode;
  className?: string;
  isEditAllowed?: boolean;
  isOpen: boolean;
  onClose: () => void;
  onEdit?: () => void;
  smallTitle?: string;
  testId: string;
  actions?: React.ReactNode;
}

const StyledModal = ({
  bigTitle,
  children,
  className = '',
  isEditAllowed = false,
  isOpen,
  onClose,
  onEdit = undefined,
  smallTitle = undefined,
  testId,
  actions = null
}: StyledModalProps) => {
  return (
    <Modal isOpen={isOpen} onCancelModal={onClose} testId={testId}>
      <div className="bg-soFresh-100 border-soFresh-140 mx-auto flex h-[90vh] w-[80vw] flex-col rounded-md border">
        <div className="bg-soFresh-100 border-soFresh-140 sticky top-0 flex justify-between rounded-t border-b border-solid px-6 py-4">
          <div className="flex flex-col">
            {smallTitle && (
              <div className="text-soFresh-180 pb-2 text-xs">{smallTitle}</div>
            )}
            <div>{bigTitle}</div>
          </div>
          <div className="flex items-center gap-5">
            {onEdit && isEditAllowed && (
              <IconButton className="p-1.5" handleOnClick={onEdit}>
                <PencilIcon
                  className="text-soClean-100 size-5"
                  data-testid="PencilIcon"
                />
              </IconButton>
            )}
            <CloseModalButton handleOnClick={onClose} btnClassName="p-0" />
          </div>
        </div>
        <div
          className={classNames(
            className,
            'flex grow flex-col gap-6 overflow-auto p-6'
          )}
        >
          {children}
        </div>
        {actions && (
          <div className="border-soFresh-140 flex items-center justify-end gap-4 border-t border-solid py-3 pr-5">
            {actions}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default StyledModal;
